/*
    Fonctions globales
 **********************************************************************************************************************/
/**
 * * [Afficher les messages d'erreur des champs du formulaire]
 * @param  {[string]} message [message à afficher dans le zone de message du formulaire]
 * @return -
 */
function displayErrorMessage(message) {
    var containerMessage = $(".creac-formulaire .alert-danger");
    // On vide le message si il y en avait un
    containerMessage.html('');
    // Affichage du message
    containerMessage.append(message).removeClass("hidden");
}



/*
    Listeners
 **********************************************************************************************************************/


 /**
 * [Permet de déplier de menu mobile]
 * @return -
 */
function menuMobile() {
    $(".navbar-toggle, .menu-mobile-overlay").click(function() {
        //Verification hauteur device :
        var heightDevice = $(window).height();
        $( ".menu-mobile-toggle > ul" ).height(heightDevice-53); // Hauteur du menu = taille device - header

        if( !$(".menu-mobile-toggle > ul").is(':animated') ) {
            // Changement d'etat du menu
            if ( $(".navbar-toggle").hasClass("open") ) {
                // Fermeture
                $( ".menu-mobile-toggle > ul" ).animate( {left: "-380"}, 300,
                    function() {
                        $(".navbar-toggle").toggleClass("open");
                        $(".menu-mobile-overlay").toggleClass("hidden");
                        $("body").css("overflow-y", '');
                    }
                );
            }
            else {
                // Ouverture
                $( ".menu-mobile-toggle > ul" ).animate( {left: "0"}, 300,
                    function() {
                        $(".navbar-toggle").toggleClass("open");
                        $(".menu-mobile-overlay").toggleClass("hidden");
                        $("body").css("overflow-y", "hidden");
                    }
                );
            }
        }
    });

    // Menu mobile - gestion du sous-menu
    $(".menu-mobile-toggle .toggle-sous-menu").click(function(event) {
        event.preventDefault();
        $(this).parent().toggleClass("active");

    });

    // Eventement : si changement de taille de la fenetre + menu ouvert (utilse si on passe de portrait à paysage)
    $(window).resize(function() {
        if ( $(".navbar-toggle").hasClass("open") ) {
            //Verification hauteur device :
            var heightDevice = $(window).height();
            $( ".menu-mobile-toggle > ul" ).height(heightDevice-53); // Hauteur du menu = taille device - header
        }
    });
}
window.menuMobile = menuMobile;


 /**
 * [Initialiser le menu fixe]
 * @param  {[classeBreakPoint]} classeBreakPoint [classe de l'element qui permet, lorsque qu'on passe dessus via le scroll, d'afficher le menu fixe]
 * @return -
 */
function initMenuFixe(classeBreakPoint, classeDecalageTop) {
    menuFixeContainer = $('.menu-fixe');
    if (classeBreakPoint != false) {
        var offsetAffix = $(classeBreakPoint).offset().top ;
    } else {
        var offsetAffix = 102; // Hauteur header
    }

    if (classeDecalageTop != false) {
        var decalageTop = $(classeDecalageTop).outerHeight();
        if ($(window).width() >= '768') {
            decalageTop = $(classeDecalageTop).outerHeight();
        } else {
            decalageTop = 0;
        }
        $( window ).resize(function() {
            if ($(window).width() >= '768') {
                decalageTop = $(classeDecalageTop).outerHeight();
            } else {
                decalageTop = 0;
            }
        });
    }

    $(window).scroll(function() {
        if ( $(window).scrollTop() >= offsetAffix ) {
            if ( !menuFixeContainer.hasClass('actif')) {
                menuFixeContainer.addClass('actif');
                menuFixeContainer.css('top', decalageTop);
            }
        } else {
            menuFixeContainer.removeClass('actif');
        }
    });
}
window.initMenuFixe = initMenuFixe;


/**
 * [Permet de styliser des radios boutons]
 * @return -
 */
function stylizedRadioButton() {
    $('.custom-radio-button a').on('click', function() {
        var clickedButton = $(this);
        var nameRadioButton = $(this).parent().data('name');
        var currentActiveButton = $(".custom-radio-button .active");

        // Si on clique sur un bouton non actif
        if (clickedButton.data('value') != currentActiveButton.data('value')) {
            clickedButton.removeClass('notActive').addClass('active');
            currentActiveButton.removeClass('active').addClass('notActive');

            $(".radio-value-"+nameRadioButton).attr("value", clickedButton.data('value'));
        }
    });
}
window.stylizedRadioButton = stylizedRadioButton;



 /**
 * [Soumission d'un formulaire ajax - gestion du loader et du message de retour]
 * @return -
 */
function ajaxSubmitForm(provenance = null, envoiEventActif = false) {
    $('.creac-formulaire .creac-contenu-formulaire').on('submit', function(event) {
        event.preventDefault();
        // Objet du formulaire
        var $this = $(this);
        var formContainer = $this.parents('.creac-formulaire');
        // Recuperation des valeurs
        var data = $this.serialize();
        var dataList = $this.serializeArray();
        var errorMessage = '';

        // Envoi de la requête HTTP en mode asynchrone
        $.ajax({
            url: $this.attr('action') + '?token=' + $this.children("input[name='_token']").val(),
            type: $this.attr('method'),
            data: data,
            beforeSend: function() {
                $('.container-loader').removeClass('hidden');
            },
            success: function(data) {
                // Affichage du conteneur possédant le message de résultat
                $('.container-loader').addClass('hidden');
                $this.addClass('hidden');
                formContainer.find('.creac-resultat-formulaire').removeClass('hidden');
                // Recuperer des données des input à afficher dans le message de résultat si besoin :
                if (formContainer.find('.afficher-value').length > 0) {
                    formContainer.find('.afficher-value').each(function(){
                        var inputName = $(this).data('name');
                        var inputData = formContainer.find("input[name='"+inputName+"']").val();
                        $(this).text(inputData);
                    });
                }

                //Si conversion
                // ga sera instancié si les cookies ont été autorisés via tarteaucitron
                if (provenance == 'inscription-mooc' && typeof ga !== 'undefined') {
                        //Gestion de l'évent de conversion qui est dans un premier temps ajouter
                        //sur Google Analytics par Jory et lui demander les noms exactes pour pouvoir compléter
                        //l'exemple ci-dessous commenté
                        //ga('send', 'event', 'category', 'action', 'opt_label', opt_value, {'nonInteraction': 1});
                        ga('send', 'event', 'Formulaires', 'Soumission', 'Inscription-Mooc');
                }

                //Si conversion AdWords
                // window.triggerGoogletrackConversion sera instancié si les cookies ont été autorisés via tarteaucitron
                if (envoiEventAnalyticsActif && window.triggerGoogletrackConversion !== undefined) {
                    window.triggerGoogletrackConversion();
                }

            },
            error: function(error) {
                $('.container-loader').addClass('hidden');
                // Affichage du message d'erreur
                if (typeof error.responseJSON !== 'undefined') {
                    messagesList = error.responseJSON;
                    errorMessage = '';
                    $.each(messagesList, function(i, message) {
                        errorMessage += message[0] + '<br />';
                    });
                    displayErrorMessage(errorMessage);
                    // Changement d'étape
                } else {
                    displayErrorMessage("Erreur lors de l'envoi du formulaire, veuillez contacter l'administrateur.");
                }
            }
        });
    });
}
window.ajaxSubmitForm = ajaxSubmitForm;


/**
 * * [Permet de scroller automatiquement jusqu'à un element]
 * @param  {[string]} element [class ou id de l'élément sur lequel on a cliqué ]
 * @return -
 */
function scrollToAncre(element = null) {
    if (element){
        $(element).on('click', 'a', function(event){
            event.preventDefault();
            // Si il y a un menu fixe : prendre en compte la hauteur de ce menu pour la position du scroll de destination
            var offsetDestination = ( $(".menu-fixe").length ) ? $( $.attr(this, 'href') ).offset().top - 60 : $( $.attr(this, 'href') ).offset().top;
            // Scroll auto
            $('html, body').animate(
                { scrollTop: $( $.attr(this, 'href') ).offset().top - 60 }, 500
            );
        });
    }
    else {
        // Bootstrap Accordeon
        $('.panel').on('shown.bs.collapse', function() {
            idPanelOuvert = "#" + $(this).children('.panel-collapse.in').attr('aria-labelledby');
            $('html, body').animate(
                { scrollTop: $(idPanelOuvert).offset().top }, 500
            );
        });
    }

}
window.scrollToAncre = scrollToAncre;


/**
 * * [Cas particulier de scrollToAncre: si il y a un id dans l'url, on scroll automatiquement au chargement de la page]
 * @param  -
 * @return -
 */
function scrollToDocumentation() {
    if ($(".page-home").length > 0){
        $(".encart-documentation, .btn-documentation, .offre-demande-renseignement").on('click', function(event){
            event.preventDefault();
            // Si il y a un menu fixe : prendre en compte la hauteur de ce menu pour la position du scroll de destination
            var offsetDestination = $("#section-demande-documentation").offset().top - 50 ;
            // Scroll auto
            $('html, body').animate(
                { scrollTop: offsetDestination }, 500
            );
        });
    }

}
window.scrollToDocumentation = scrollToDocumentation;



 function colorationEtoile() {
    $('.star-rating .fa').each(function(index) {
        if (parseInt($('input.rating-value').val()) >= parseInt($(this).data('rating'))) {
            return $(this).removeClass('fa-star-o').addClass('fa-star');
        } else {
            var moduloNote = ($('input.rating-value').val() % index).toPrecision(2);
            if (moduloNote > 0.30 && moduloNote  < 0.80) {
                return $(this).removeClass('fa-star-o').addClass('fa-star-half-o');
            } else if (moduloNote >= 0.80 && moduloNote <= 1.00) {
                return $(this).removeClass('fa-star-o').addClass('fa-star');
            }
            return $(this).removeClass('fa-star').addClass('fa-star-o');
        }
    });
}
window.colorationEtoile = colorationEtoile;


function filtrerCentreInteretListener() {
    $(".btn-filtre-centreinteret").click(function() {
        $(".btn-filtre-centreinteret").removeClass('btn-primary').addClass('btn-secondary');
        $(this).addClass('btn-primary').removeClass('btn-secondary');

        var centreInteret = $(this).data('idcinteret');
        if (centreInteret == "tous") {
             $(".toggle-filtre-centreinteret").show();
        } else {
            $(".toggle-filtre-centreinteret").hide();
            $(".toggle-filtre-centreinteret[data-idcinteret="+centreInteret+"]").show();
        }
    });
}
window.filtrerCentreInteretListener = filtrerCentreInteretListener;




function initOngletFaq(){
    $('.gestion-deuxieme-onglet').on( "click", function(e) {
        var button = $(this);
        var ongletAssocie = $(this).siblings('.deuxieme-niveau-onglet');
        var iconeEnsemble = $('.gestion-deuxieme-onglet').children('ul').children('li').children('a').children('i');
        var icone = $(this).children('ul').children('li').children('a').children('i');

        gestionDesOnglets(button, ongletAssocie, $('.deuxieme-niveau-onglet'), iconeEnsemble, icone, true);
    });
}
window.initOngletFaq = initOngletFaq;

function gestionDesOnglets(button, ongletAssocie, onglet, iconeEnsemble, icone, iconeFleche){
    if(iconeFleche){
        $(iconeEnsemble).addClass('fa-chevron-right');
        $(iconeEnsemble).removeClass('fa-chevron-down');
    }else{
        $(iconeEnsemble).removeClass('fa-minus-square-o');
        $(iconeEnsemble).addClass('fa-plus-square-o');
    }

    if($(ongletAssocie).is(':visible')){
        $(ongletAssocie).hide( "midle");
    }else{
        $(onglet).hide( "midle");
        $(ongletAssocie).show( "midle");
        //
        if(iconeFleche){
            $(icone).addClass('fa-chevron-down');
            $(icone).removeClass('fa-chevron-right');
        }else{
            $(icone).removeClass('fa-plus-square-o');
            $(icone).addClass('fa-minus-square-o');
        }
    }
}

/**
 * * [Anitialise les date picker dans l'admin]
 * @param  -
 * @return -
 */
// function initAdminDatePicker() {

//     $('.datepicker').datepicker({
//         language : "fr",
//         format: "mm/dd/yyyy"
//     });
// }
// window.initAdminDatePicker = initAdminDatePicker;
